<template>
  <div
    :class="[
      $style.upload,
      direction === 'row' ? $style.row : $style.col,
      type === 'normal' ? $style.upload_normal : $style.upload_wx,
    ]"
  >
    <!-- 上传前 -->
    <el-upload
      v-if="type === 'wx' || !imgUrl"
      :class="$style.upload_wrap"
      action=""
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
    >
      <img
        v-if="type === 'normal'"
        :class="$style.upload_icon"
        src="@assets/image/camera.png"
        alt=""
      />
      <Button v-else :class="$style.wx_btn">上传微信图片</Button>
    </el-upload>

    <!-- 上传成功 -->
    <div v-if="imgUrl && type === 'normal'" :class="$style.upload_success">
      <img :class="$style.upload_img" :src="imgUrl" />
      <div :class="$style.delete_btn" @click="deleteImage">
        <div :class="$style.delete_btn__inner">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>

    <!-- 提示描述 -->
    <span v-if="type === 'normal'" :class="$style.upload_desc">
      上传证件照正面
    </span>
  </div>
</template>

<script>
export default {
  name: "UploadImage",
  props: {
    type: {
      // normal - 方形上传按钮， wx - 个人上传微信图片的按钮
      type: String,
      default: "normal",
    },
    imageUrl: {
      type: String,
      default: "",
    },
    direction: {
      // row - 水平，col - 垂直
      type: String,
      default: "row",
    },
  },
  data() {
    return {
      imgUrl: "",
    };
  },
  watch: {
    imageUrl(v) {
      this.imgUrl = v;
    },
  },
  methods: {
    beforeUpload(file) {
      if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
        this.$message({
          message: "图片要求上传jpg或png格式或者jpeg格式",
          type: "warning",
        });
        return false;
      }

      if (this.type === "normal" && file.size > 1048576) {
        this.$message({ message: "图片大小不能超过1M", type: "warning" });
        return false;
      }

      const imageUrl = window.URL.createObjectURL(file);
      this.imgUrl = imageUrl;
      this.$emit("change", { file, imageUrl });

      return false;
    },

    uploadSuccess() {},

    deleteImage() {
      this.imgUrl = "";
      this.$emit("change", { file: null, imageUrl: "" });
    },
  },
};
</script>

<style lang="scss" module scoped>
.upload {
  display: flex;
  align-items: center;
  gap: 20px;

  &.row {
    flex-direction: row;
  }

  &.col {
    flex-direction: column;
  }

  &.upload_normal {
    .upload_wrap {
      flex-shrink: 0;
      width: 200px;
      height: 120px;
      transition: all 0.3s;
      border: $border-1;
      cursor: pointer;

      &:hover {
        border-color: $theme-color;
      }

      :global {
        ::v-deep .el-upload {
          width: 100%;
          height: 100%;
          @include flex();
        }
      }

      .upload_icon {
        width: rem(40);
        object-fit: cover;
      }
    }

    .upload_success {
      flex-shrink: 0;
      width: 200px;
      height: 120px;
      position: relative;

      .upload_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .delete_btn {
        display: none;
        position: absolute;
        top: 5px;
        right: 5px;
        width: 20px;
        height: 20px;
        cursor: pointer;

        .delete_btn__inner {
          width: 20px;
          height: 20px;
          background: $theme-color;
          border-radius: 50%;

          @include flex();
          :global {
            .el-icon-close {
              color: $white;
              transform: translateX(-1px);
            }
          }
        }
      }

      &:hover {
        .delete_btn {
          display: block;
        }
      }
    }

    .upload_desc {
      flex-shrink: 0;
      min-width: 100px;
      font-size: rem(14);
      color: #898989;
      text-align: center;
      line-height: rem(28);
    }
  }

  &.upload_wx {
    .wx_btn {
      color: #666;
      background-color: $white;
      border: 1px solid #999;
      transition: all 0.24s;

      &:hover {
        color: $white;
        background-color: #999;
      }
    }
  }
}
</style>
